// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"702":"ee3f217e","2612":"a6506f96","3153":"eee0283e","8118":"c40a7f2b","9751":"45e45977"}[chunkId] + ".chunk.css";
};